import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, } from 'react-bootstrap';
import { BiListOl, BiRefresh } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';
import Iframe from 'react-iframe';

const Documents = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [listDocument, setlistDocument] = useState([]);
    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);
    const [urlDoc, seturlDoc] = useState(null)

    const loadInit = async () => {
        setIsLoading(true)
        // let param = `norecfk=${$('#norecPd').val()}`;
        let param = `noregistrasi=${$('#noRegistrasi').text()}`;

        try {
            const promise1 = await VedikaService.dokumenVedika(param)
            const allPromise = await Promise.all([promise1]);
            setlistDocument(allPromise[0].data.data)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }
    const handleShowFile = (row) => {
        setshowDeskripsi(true);
        let url = '';
        if (row.url.slice(0, 5) == "http:") {
            // setTimeout(() => {
            url = row.url.replace('http://smart.rsabhk.co.id', 'https://vedika.rsabhk.co.id');
            //     $('#frameFile').attr("src", row.url.replace('http://smart.rsabhk.co.id', 'https://vedika.rsabhk.co.id'));
            // }, 2000);
        } else {
            // setTimeout(() => {
            url = row.url.replace('https://smart.rsabhk.co.id', 'https://vedika.rsabhk.co.id')
            //     $('#frameFile').attr("src", row.url.replace('https://smart.rsabhk.co.id', 'https://vedika.rsabhk.co.id'));
            // }, 2000);
        }
        seturlDoc(url);
    }



    const loadDtListFile = () => {
        $('#dtListFile').DataTable({
            data: listDocument,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: 'tanggal_document',
                    width: '15%',
                },
                {
                    targets: [1],
                    data: 'nam_file',
                    width: '40%',
                },
                {
                    targets: [2],
                    data: 'nama_kategori',
                    width: '10%',
                },
                {
                    targets: [4],
                    data: 'jenisberkas',
                    width: '15%',
                },
                {
                    targets: [5],
                    data: null,
                    width: '10%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Files' onClick={() => handleShowFile(rowData)}><BiListOl /></Button></ButtonGroup></div>),
                },
            ]
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(()=>{
        loadDtListFile();
    },[listDocument])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Document</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtListFile' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th>Tanggal Upload</th>
                                <th>Nama File</th>
                                <th>Kategori</th>
                                <th>Jenis</th>
                                <th>File</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='xl'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Document view</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            {/* <iframe id='frameFile' width="750" height="600"></iframe> */}
                            <Iframe
                                url={urlDoc}
                                width="1100px"
                                height="700px"

                                display="block"
                                position="relative"
                            />
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Documents;